import { useAuth0 } from "@auth0/auth0-react";
import PreSchoolService from "Lib/API/PreSchool";
import { ReactComponent as BlankLink } from 'assets/icons/Group 240018.svg';
import DateIconSvg from 'assets/icons/svg/Date.svg';
import { InputField, LabelField, SelectField } from 'components';
import AlertDialog from "components/Dialog";
import MyButton from "components/MyButton";
import MyModal from "components/MyModal";
import { PhonePicker } from "components/PhonePicker";
import { Formik } from "formik";
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { toastr } from "react-redux-toastr";
import { getMaxDate, getMinDate } from "utils/dateRange";
import { formatPhoneNumber } from "utils/phoneNumberFormat";
import { emailValidation } from "utils/validation";
import { DatePickerWrapper } from '../Theme';
import { FormViwer } from './FormViwer';
import './ParticipantDrawer.scss';
import { DateIcon, Files, Label } from './Theme';
import { Box, Typography, Skeleton } from "@mui/material";
import { fontConfig } from "theme/fontConfig";

const UserDetailsTabComponent = ({ participantInfo,afterUpdatedParticipantHandler }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [viewForm, setViewForm] = useState()
  const [isLoading, setIsLoading] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);

  const titleStyle = {
    fontFamily: fontConfig.EventsTitleFont.family,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '18px',
    color: '#4F4F4F',
  }
  function convertUTCToLocalDate(date) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate()
    );
    return date;
  }

  const handleDownload = async (file) => {
    const link = document.createElement("a");
    link.href = file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  const formSchema = [
    { label: 'First Name', element: 'firstName', value: participantInfo?.firstName },
    { label: 'Last Name', element: 'lastName', value: participantInfo?.lastName },
    { label: 'Email', element: 'email', value: participantInfo?.email },
    { label: 'Phone Number', element: 'phone', value: participantInfo?.phone}
  ]  
  participantInfo?.formData && Object.entries(participantInfo?.formData).forEach(([key, value]) => {
    if (key?.split('_')[0] === 'checkboxes' || key?.split('_')[0] === 'radiobuttons') {
      formSchema.push({
        label: value[0]?.label || value?.label || key?.split('_')[0], element: key?.split('_')[0], value: value
      })

    } else {
      formSchema.push({ label: key?.split('-')[0], element: key?.split('-')[0], value: value })
    }
  });

  
  const checkDisabledSubmitButton = ( values) => {

    if(values?.first_name?.trim() === participantInfo?.firstName && values?.last_name?.trim() === participantInfo?.lastName && values?.email?.trim() === participantInfo?.email && values?.phone?.trim() === participantInfo?.phone){
      return true;
    }

    if(!values?.first_name?.trim() || !values?.last_name?.trim() || !values?.email?.trim() || !values?.phone?.trim()){
      return true;
    }
    return false;
  }

  const updateEventParticipant = async (values) => {
    if(checkDisabledSubmitButton(values)){
      toastr.info('Please fill all the required fields!');
      return;
    }
    if(!emailValidation(values?.email)){
      toastr.info('Please enter a valid email!');
      return;
    }

    // const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
    // if(values?.phone && !phoneRegex.test(values?.phone)){
    //   toastr.info('Please enter a valid phone number!');
    //   return;
    // }

    setIsLoading(true);
    const token = await getAccessTokenSilently();
    const participantData = {
      firstName: values?.first_name,
      lastName: values?.last_name,
      email: values?.email,
      phone: values?.phone,
    }
    PreSchoolService.updateEventParticipant(token, participantData, 
      participantInfo?._id).then((response) => {
      toastr.success('Success', 'Participant updated successfully!');
      afterUpdatedParticipantHandler()
    }).catch((error) => {
      toastr.error(error?.data?.message || 'Something went wrong!');
    }).finally(() => {
      setIsLoading(false);
    })
  }
  const initialValues = {
    first_name: participantInfo?.firstName,
    last_name: participantInfo?.lastName,
    email: participantInfo?.email,
    phone: participantInfo?.phone,
  }


  const onUpdateFormParticipant = (values) => {
    setViewForm(values);
    afterUpdatedParticipantHandler(values);
  }

  const closeModal = () => {
    setConfirmClose(true);
      setViewForm(false) 
  }
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    setViewForm(false) 
  }


  return (
    // <div>
    //    <Formik
    //     initialValues={initialValues}
    //     onSubmit={(values,actions) => {
    //       updateEventParticipant(values);
    //     }}
    //     // validate={(values) => {
    //     //   const errors = {};
    //     //   if (!values.first_name.trim()) {
    //     //     errors.first_name = "Required";
    //     //   }
    //     //   if (!values.last_name.trim()) {
    //     //     errors.last_name = "Required";
    //     //   }
    //     //   if (!values.date_of_birth) {
    //     //     errors.date_of_birth = "Required";
    //     //   }
    //     //   return errors;
    //     // }}
    //   >
    //     {({ 
    //       values, 
    //       handleReset, 
    //       handleSubmit, 
    //       handleChange, 
    //       handleBlur,
    //       setFieldValue,
    //       errors,
    //     }) => (
    //       <div>
    //         <Row style={{ marginBottom: '20px' }}>
    //           <Col className="col-sm-6">
    //             <InputField
    //               titleStyle={titleStyle}
    //               style={{ background: '#f6f6f6', color: '#002E5C' }}
    //               title={'First Name'}
    //               name="first_name"
    //               checkValidation={true}
    //               value={values?.first_name}
    //               handleChange={(e) => { 
    //                 const {  value } = e.target;
    //                 setFieldValue("first_name", value);
    //               }}
    //               readOnly={false}
    //               onKeyPress={(e) => {
    //                 if (e.key === 'Enter') {
    //                   e.preventDefault();
    //                 }
    //               }}
    //             />
    //           </Col>
    //           <Col className="col-sm-6">
    //             <InputField
    //               titleStyle={titleStyle}
    //               style={{ background: '#f6f6f6', color: '#002E5C' }}
    //               title={'Last Name'}
    //               name="last_name"
    //               checkValidation={true}
    //               value={values?.last_name}
    //               handleChange={(e) => {
    //                 const { value } = e.target;
    //                 setFieldValue("last_name", value);
    //                }}
    //               readOnly={false}
    //               onKeyPress={(e) => {
    //                 if (e.key === 'Enter') {
    //                   e.preventDefault();
    //                 }
    //               }}
    //             />
    //           </Col>
    //         </Row>
    //         <Row style={{ marginBottom: '20px' }}>
    //           <Col className="col-sm-6">
    //             <InputField
    //               titleStyle={titleStyle}
    //               style={{ background: '#f6f6f6', color: '#002E5C' }}
    //               title={'Email'}
    //               name="email"
    //               checkValidation={true}
    //               value={values?.email}
    //               handleChange={(e) => {
    //                 const { value } = e.target;
    //                 setFieldValue("email", value);
    //                }}
    //               readOnly={false}
    //               onKeyPress={(e) => {
    //                 if (e.key === 'Enter') {
    //                   e.preventDefault();
    //                 }
    //               }}
    //               copy={true}
    //             />
    //           </Col>
    //           <Col className="col-sm-6">
    //             <InputField
    //               titleStyle={titleStyle}
    //               style={{ background: '#f6f6f6', color: '#002E5C' }}
    //               title={'Phone Number'}
    //               name="phone"
    //               checkValidation={true}
    //               value={values?.phone}
    //               handleChange={(e) => {
    //                 const { value } = e.target;
    //                 setFieldValue("phone", value);
    //                }}
    //               readOnly={false}
    //               onKeyPress={(e) => {
    //                 if (e.key === 'Enter') {
    //                   e.preventDefault();
    //                 }
    //               }}
    //             />
    //           </Col>
    //         </Row>
           
    //         <Row className="mt-5">
    //           <Col className="col-sm-12 d-flex justify-content-end">
    //             <MyButton
    //               type={"submit"}
    //               content={isLoading ? <span className="spinner spinner-gray mr-4"></span> : "Save"}
    //               onClick={handleSubmit}
    //               style={{ width: "130px" }}
    //               disabled={checkDisabledSubmitButton(values)}
                  

    //             />
    //           </Col>
    //         </Row>
    //       </div>
    //     )}
    //   </Formik>
      
      
    //   <br />

    //   <div className="text-primary" role="button" 
    //   onClick={() => { setViewForm(!viewForm) }}
    //   >
    //     <BlankLink className="mr-2 mb-1" /> View Form Response
    //   </div>
    //   <hr />
    //   <div className="files__container">
    //     <div className="files__title">
    //       {`Files(${participantInfo?.files?.length})`}
    //     </div>
    //     <Files>
    //       {participantInfo?.files.map((file, index) => (
    //         <li onClick={() => { handleDownload(file) }}>file {index + 1}</li>
    //       ))}
    //     </Files>
    //   </div>
    //   <MyModal
    //     open={viewForm}
    //     className="view-form-modal"
    //     onClose={closeModal}
    //   >
    //     <FormViwer formData={participantInfo} formSchema={formSchema} handleDownload={handleDownload} participantId={participantInfo?._id} 
    //     onUpdateFormParticipant={onUpdateFormParticipant}/>
    //   </MyModal>
    //   <AlertDialog
    //     open={confirmClose}
    //     onDecline={() => {
    //       setConfirmClose(false);
    //     }}
    //     onAccept={confirmCloseHandler}
    //     title={"Are you sure?"}
    //     description={"Do you want to discard the changes you made?"}
    //   />
    // </div>
     <div>
           {/* <Formik
            initialValues={initialValues}
            onSubmit={(values,actions) => {
              updateEventParticipant(values);
            }}
            // validate={(values) => {
            //   const errors = {};
            //   if (!values.first_name.trim()) {
            //     errors.first_name = "Required";
            //   }
            //   if (!values.last_name.trim()) {
            //     errors.last_name = "Required";
            //   }
            //   if (!values.date_of_birth) {
            //     errors.date_of_birth = "Required";
            //   }
            //   return errors;
            // }}
          >
            {({ 
              values, 
              handleReset, 
              handleSubmit, 
              handleChange, 
              handleBlur,
              setFieldValue,
              errors,
            }) => (
              <div>
                <Row style={{ marginBottom: '20px' }}>
                  <Col className="col-sm-6">
                    <InputField
                      titleStyle={titleStyle}
                      style={{ background: '#f6f6f6', color: '#002E5C' }}
                      title={'First Name'}
                      name="first_name"
                      checkValidation={true}
                      value={values?.first_name}
                      handleChange={(e) => { 
                        const {  value } = e.target;
                        setFieldValue("first_name", value);
                      }}
                      readOnly={false}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Col>
                  <Col className="col-sm-6">
                    <InputField
                      titleStyle={titleStyle}
                      style={{ background: '#f6f6f6', color: '#002E5C' }}
                      title={'Last Name'}
                      name="last_name"
                      checkValidation={true}
                      value={values?.last_name}
                      handleChange={(e) => {
                        const { value } = e.target;
                        setFieldValue("last_name", value);
                       }}
                      readOnly={false}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Col>
                </Row>
                <Row style={{ marginBottom: '20px' }}>
                  <Col className="col-sm-6">
                    <InputField
                      titleStyle={titleStyle}
                      style={{ background: '#f6f6f6', color: '#002E5C' }}
                      title={'Email'}
                      name="email"
                      checkValidation={true}
                      value={values?.email}
                      handleChange={(e) => {
                        const { value } = e.target;
                        setFieldValue("email", value);
                       }}
                      readOnly={false}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                        }
                      }}
                      copy={true}
                    />
                  </Col>
                  <Col className="col-sm-6">
                  <InputField
                      titleStyle={titleStyle}
                      style={{ background: '#f6f6f6', color: '#002E5C' }}
                      title={'Phone Number'}
                      name="phone"
                      checkValidation={true}
                      value={values?.phone}
                      handleChange={(e) => {
                        const { value } = e.target;
                        setFieldValue("phone", value);
                       }}
                      readOnly={false}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Col>
                </Row>
               
                <Row className="mt-5">
                  <Col className="col-sm-12 d-flex justify-content-end">
                    <MyButton
                      type={"submit"}
                      content={isLoading ? <span className="spinner spinner-gray mr-4"></span> : "Save"}
                      onClick={handleSubmit}
                      style={{ width: "130px" }}
                      disabled={checkDisabledSubmitButton(values)}
                      
    
                    />
                  </Col>
                </Row>
              </div>
            )}
          </Formik>
          
          
          <br /> */}
    <Box display="flex" justifyContent="space-between">
          <div className="text-primary" role="button" 
          onClick={() => { setViewForm(!viewForm) }}
          >
            <BlankLink className="mr-2 mb-1" /> View Form Response
          </div>
          {/* <hr /> */}
          <div className="files__container">
            <div className="files__title">
              {`Files(${participantInfo?.files?.length})`}
            </div>
            <Files>
              {participantInfo?.files?.map((file, index) => (
                <li onClick={() => { handleDownload(file) }}>file {index + 1}</li>
              ))}
            </Files>
          </div>
          </Box>
          <MyModal
            open={viewForm}
            className="view-form-modal"
            onClose={closeModal}
            PaperProps={{
              style: {
                minHeight: "auto",
                maxHeight: "94vh",
                background: "#fff",
                borderRadius: "10px",
              }
            }}
          >
            <div style={{
              fontWeight: "700",
              display: "flex",
              fontStyle: "normal",
              fontSize: "20px",
              justifyContent: "center",
              color: "#002E5C",
              paddingTop: "15px",
              paddingBottom: "20px",
            }}>User Details</div>
            <FormViwer formData={participantInfo} formSchema={formSchema} handleDownload={handleDownload} participantId={participantInfo?._id} 
            onUpdateFormParticipant={onUpdateFormParticipant}/>
          </MyModal>
          {/* <AlertDialog
            open={confirmClose}
            onDecline={() => {
              setConfirmClose(false);
            }}
            onAccept={confirmCloseHandler}
            title={"Are you sure?"}
            description={"Do you want to discard the changes you made?"}
          /> */}
        </div>
  );
};


export default UserDetailsTabComponent;
